import React from "react";
import style from "../styles/credentials.module.css";
import { motion } from "framer-motion";
import Reveal from "../components/reveal";
import { TbSchool, TbCertificate, TbTrophy, TbUsersGroup } from "react-icons/tb";
import {
  education,
  certifications,
  achievements,
  leadership,
} from "../data/profile";

const Credentials = () => {
  const cards = [
    {
      id: "education",
      icon: <TbSchool />,
      title: "Education",
      body: (
        <div className={style.item}>
          <h4>{education.degree}</h4>
          <p className={style.org}>
            {education.institution}
            {education.location && ` · ${education.location}`}
          </p>
          <div className={style.metaRow}>
            <span className={style.period}>{education.period}</span>
            <span className={style.pill}>{education.score}</span>
          </div>
        </div>
      ),
    },
    {
      id: "certifications",
      icon: <TbCertificate />,
      title: "Certifications",
      body: certifications.map((cert) => (
        <div className={style.item} key={cert.title}>
          <h4>{cert.title}</h4>
          <p className={style.org}>{cert.issuer}</p>
        </div>
      )),
    },
    {
      id: "achievements",
      icon: <TbTrophy />,
      title: "Achievements",
      body: achievements.map((item) => (
        <div className={style.item} key={item.title}>
          <h4>
            {item.title} <span className={style.pill}>{item.result}</span>
          </h4>
          <p className={style.org}>{item.prize}</p>
          {item.detail && <p className={style.detail}>{item.detail}</p>}
        </div>
      )),
    },
    {
      id: "leadership",
      icon: <TbUsersGroup />,
      title: "Leadership",
      body: leadership.map((item) => (
        <div className={style.item} key={item.id}>
          <h4>{item.role}</h4>
          <p className={style.org}>{item.org}</p>
          <span className={style.period}>{item.period}</span>
          <p className={style.detail}>{item.point}</p>
        </div>
      )),
    },
  ];

  return (
    <section id="credentials" className={`sectionShell ${style.credentials}`}>
      <div className="sectionInner">
        <Reveal dir="up" amount={0.4}>
          <h2 className="sectionHeading" data-outline="Credentials">
            Credentials
          </h2>
        </Reveal>

        <div className={style.grid}>
          {cards.map((card, i) => (
            <Reveal
              dir="up"
              delay={i * 0.08}
              amount={0.12}
              key={card.id}
              className={style.cardWrap}
            >
              <motion.div
                className={style.card}
                whileHover={{ y: -8 }}
                transition={{ type: "spring", stiffness: 260, damping: 22 }}
              >
                <div className={style.cardHead}>
                  <span className={style.icon}>{card.icon}</span>
                  <h3>{card.title}</h3>
                </div>
                {card.body}
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Credentials;
